import React, { useEffect, useState } from 'react';
import CreatableSelect from 'react-select/creatable';
import { Row, Col, Form, Button, InputGroup, Popover, OverlayTrigger } 
from 'react-bootstrap';
import Accordion from 'react-bootstrap/Accordion';
import Card from 'react-bootstrap/Card';
import Pagination from 'react-bootstrap/Pagination';
import CustomToggle from '../custom-toggle/CustomToggle';
import { roundNumber } from '../../Utils.js'
import * as Icon from 'react-bootstrap-icons';
import 'bootstrap/dist/css/bootstrap.min.css';

const  DebtForm = (props) => {
  const [paymentPages, setPaymentPages] = useState({});
  const [paymentPageSizes, setPaymentPageSizes] = useState({});
  const [visibleTransactions, setVisibleTransactions] = useState({});

  const getPaymentTimestamp = dateValue => {
    const dateText = String(dateValue || '').trim();
    const dayFirstDate = dateText.match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{2,4})$/);
    if (dayFirstDate) {
      const day = Number(dayFirstDate[1]);
      const month = Number(dayFirstDate[2]);
      const year = Number(dayFirstDate[3].length === 2 ? `20${dayFirstDate[3]}` : dayFirstDate[3]);
      const timestamp = Date.UTC(year, month - 1, day);
      const parsedDate = new Date(timestamp);
      return parsedDate.getUTCFullYear() === year &&
        parsedDate.getUTCMonth() === month - 1 &&
        parsedDate.getUTCDate() === day ? timestamp : 0;
    }
    const timestamp = Date.parse(dateText);
    return Number.isNaN(timestamp) ? 0 : timestamp;
  };

  const statusOptions = [
    {value: 1, desc: "Not Started"},
    {value: 2, desc: "In Progress"},
    {value: 3, desc: "Paused"},
    {value: 4, desc: "Complete"},
  ]

  useEffect(() => {
    props.handleDebtRefresh(props.yearCalc, props.remaining, props.selectedSort);
  }, [props.remaining])

  const calculateRemaining = field =>{
    if (props.data.manual) {
      return (field.weekly?Number(field.periodWeekly):Number(field.period)) - Number(field.noOfPayments);
    } else {
      return Number(props.data.totalPeriod) - Number(field.noOfPayments);
    }
  }

  const popover = props => {
    return (
    props.amount===""?
    <Popover id="popover-basic">
      <Popover.Header as="h3">Summary</Popover.Header>
      <Popover.Body><p>No info</p></Popover.Body>
    </Popover>:
    <Popover id="popover-basic">
      <Popover.Header as="h3">Summary</Popover.Header>
      <Popover.Body>
        <p><strong>{props.company}</strong><br/>
        {statusOptions.filter(f => f.value === Number(props.status))[0].desc}<br/>
        Payment per {props.weekly?'week £' + props.weeklyIndividual:'month £' +
        props.monthlyIndividual + ' (£' + props.weeklyIndividual + ' weekly)'}</p>
      </Popover.Body>
    </Popover>
  )};

  const [showComplete, setShowComplete] = useState(true);

  return (
    <>
    <Row>
      <Col xs={11} md={6} lg={2}>
        <h2>{props.title} ({props.data.records.filter(r => r.status !== 4).length})</h2>
      </Col>
      <Col xs={11} md={4} lg={2} style={{paddingTop: '10px'}}>
        <Form.Check
          type="switch"
          id="complete-switch"
          checked={showComplete}
          label="Show completed debt"
          onChange={() => setShowComplete(!showComplete)}
        />
      </Col>
      <Col xs={11} md={6} lg={2} style={{paddingTop: '10px'}}>
       Available for debt: £{props.remaining.toFixed(2)}
      </Col>
    </Row>
    <Form>
      <Row>
        <Col xs={11} md={4} lg={2} style={{marginTop: "5px"}}>
          <Form.Check
            type="switch"
            id="manual-switch"
            checked={props.data.manual}
            label="Auto/Manual payments"
            onChange={() => props.handleManualSwitch()}
          />
        </Col>
        {!props.data.manual?
        <>
        <Col xs={12} md={3} style={{marginTop: "5px"}}>
        <Form.Check
            inline
            label="Percentage"
            name="snowball"
            type='radio'
            id={`percentage`}
            value='PERCENTAGE'
            checked={props.data.repaymentType === 'PERCENTAGE'}
            onChange={() => props.handleRepaymentType(props.yearCalc, 'PERCENTAGE', props.remaining, props.selectedSort)}
          />
          <Form.Check
            inline
            label="Snowball"
            name="snowball"
            type='radio'
            id={`snowball`}
            value='SNOWBALL'
            checked={props.data.repaymentType === 'SNOWBALL'}
            onChange={() => props.handleRepaymentType(props.yearCalc, 'SNOWBALL', props.remaining, props.selectedSort)} 
          />
          <Form.Check
            inline
            label="Avalanche"
            name="snowball"
            type='radio'
            id={`avalanche`}
            value='AVALANCHE'
            checked={props.data.repaymentType === 'AVALANCHE'}
            onChange={() => props.handleRepaymentType(props.yearCalc, 'AVALANCHE', props.remaining, props.selectedSort)}
          />
        </Col>
        <Col xs={11} md={2} lg={1}>
        <InputGroup>
          <InputGroup.Text>Period:</InputGroup.Text>
            <Form.Control
              disabled={props.data.repaymentType==='PERCENTAGE'?false:true}
              type="number"
              name="overallPeriod"
              placeholder="Period"
              onChange={(event) => props.handleChangeDebtPeriod(event, props.remaining, props.selectedSort)}
              value={props.data.totalPeriod}
            />
          </InputGroup>
        </Col>
        <Col xs={11} md={4} lg={2} style={{marginTop: "5px"}}>
          <Form.Check
            type="switch"
            id="auto-weekly-switch"
            value={props.data.weekly}
            label="Monthly/Weekly payments"
            onChange={() => props.handleAutoWeekly()}
          />
        </Col>
        <Col xs={11} md={3} lg={1}>
          <Button variant="primary" onClick={() => 
            props.handleAddAutoPayment(props.yearCalc, props.remaining, props.selectedSort)}>
              Add Payment
          </Button>
        </Col>
        </>:<></>
        }
        <Col xs={11} md={{ span: 5, offset: 1}} lg={{ span: 2, offset: 1}}>
        <InputGroup className="mb-1">
          <InputGroup.Text>Order by:</InputGroup.Text>
            <Form.Select aria-label="select sort"
              key="sort"
              id="sort-select"
              value={props.selectedSort}
              onChange={(e) => {
                props.setSelectedSort(e.target.value);
                props.handleDebtSort(e.target.value);
              }}
            >
              {props.sortOptions.map((s) => (<option key={s.value} value={s.value}>{s.option}</option>))}
            </Form.Select>
          </InputGroup>
        </Col>
      </Row>
    </Form>
    <div className="debt-data-scroll-wrapper">
    <Row className="debt-data-scroll">
    {props.data.records.filter(debt => showComplete === (debt.status===4) || debt.status!==4).map((field, index) => {
      const debtKey = field.id || index;
      const transactionsVisible = Boolean(visibleTransactions[debtKey]);
      const pageSizeSelection = paymentPageSizes[debtKey] || '5';
      const currentPage = paymentPages[debtKey] || 1;
      const sortedPayments = field.paymentHistory
        .map((payment, paymentIndex) => ({
          payment,
          paymentIndex,
          timestamp: getPaymentTimestamp(payment.date),
        }))
        .sort((first, second) => second.timestamp - first.timestamp || second.paymentIndex - first.paymentIndex);
      const pageSize = pageSizeSelection === 'all' ? sortedPayments.length || 1 : 5;
      const pageCount = Math.max(1, Math.ceil(sortedPayments.length / pageSize));
      const visiblePage = Math.min(currentPage, pageCount);
      const visiblePayments = pageSizeSelection === 'all' ? sortedPayments :
        sortedPayments.slice((visiblePage - 1) * pageSize, visiblePage * pageSize);

      return (
      <React.Fragment key={field.id || index}>
      <Accordion>
        <Form>
          <Card>
          <OverlayTrigger trigger={["hover", "focus"]} placement="top" overlay={popover(field)}>
            <Card.Header className={field.status===4?'completed':''}>
              <Row className="debt-card-fields">
              <Col className="debt-card-field debt-card-type">
                <Form.Label className="my-0 py-0"
                  htmlFor={'type-'+index}>Type</Form.Label>
                <CreatableSelect
                  isDisabled={field.status===4?true:false}
                  key={'type-'+index}
                  id={'type-'+index}
                  isClearable
                  className="react-select-style mt-0"
                  onChange={(event) => {
                   props.handleChange(index, event, props.yearCalc, props.remaining, props.selectedSort);
                  }}
                  placeholder="Select or create your type"
                  onCreateOption={(e) => props.handleCreateDescription(e, index)}
                  options={props.data.descriptions}
                  value={{'label':field.description}}
                />
              </Col>
              <Col className="debt-card-field">
                <Form.Label className="my-0 py-0"
                  htmlFor={'company-'+index}>Company</Form.Label>
                <Form.Control
                  disabled={field.status===4?true:false}
                  key={'company-'+index}
                  id={'company-'+index}
                  className="mt-0"
                  type="text"
                  name="company"
                  placeholder="Optional"
                  value={field.company}
                  onChange={(event) => {
                    props.handleChange(index, event, props.yearCalc, props.remaining, props.selectedSort);
                  }}
                />
              </Col>
              <Col className="debt-card-field">
                <Form.Label className="my-0 py-0"
                  htmlFor={'collector-'+index}>Collector
                </Form.Label>
                <Form.Control
                  disabled={field.status===4?true:false}
                  key={'collector-'+index}
                  id={'collector-'+index}
                  className="mt-0"
                  type="text"
                  name="collector"
                  placeholder="Optional"
                  value={field.collector}
                  onChange={(event) => {
                    props.handleChange(index, event, props.yearCalc, props.remaining, props.selectedSort);
                  }}
                />
              </Col>
              <Col className="debt-card-field">
                <Form.Label className="my-0 py-0"
                  htmlFor={'amount-'+index}>Amount</Form.Label>
                <InputGroup>
                  <InputGroup.Text>£</InputGroup.Text>
                  <Form.Control
                    disabled={field.status===4?true:false}
                    key={'amount-'+index}
                    id={'amount-'+index}
                    className="mt-0"
                    type="number"
                    name="amount"
                    placeholder="Enter Amount"
                    value={field.amount}
                    onBlur={(event) => {props.handleUpdate(index, event, props.yearCalc, props.remaining, props.selectedSort)}}
                    onChange={(event) => {
                      props.handleChange(index, event, props.yearCalc, props.remaining, props.selectedSort);
                    }}
                  />
                </InputGroup>
              </Col>
              <Col className="debt-card-field debt-card-balance">
                <Form.Label className="my-0 py-0"
                  htmlFor={'currentBalance-'+index}>Current Balance
                </Form.Label>
                <InputGroup>
                  <InputGroup.Text>£</InputGroup.Text>
                  <Form.Control
                    disabled
                    key={'currentBalance-'+index}
                    id={'currentBalance-'+index}
                    className="mt-0"
                    type="number"
                    name="currentBalance"
                    value={Number(field.currentBalance).toFixed(2)}
                  />
                </InputGroup>
              </Col>              
              </Row>
              <div className="debt-card-actions">
              <CustomToggle eventKey={''+index}></CustomToggle>
              </div>
            </Card.Header>
            </OverlayTrigger>
            <Accordion.Collapse eventKey={''+index}>
              <Card.Body>
                {props.data.manual?
                <>
                <Row className="pb-3">
                  <Col xs={12} lg={3} className="text-lg-end my-auto">
                    Calculated using the manual inputs
                    <br/>
                    <Form.Check
                      id={"current-amt-calc"+index}
                      style={{fontSize: '0.8em'}}
                      reverse
                      name="currentBalanceCalc"
                      type="switch"
                      key={"current-amt-calc"+index}
                      value={field.currentBalanceCalc}
                      label="Calculate changes using current balance"
                      onChange={(event) => {
                        props.handleChange(index, event, props.yearCalc, props.remaining, props.selectedSort);
                      }}
                    />
                  </Col>
                  <Col xs={11} md={5} lg={1}>
                    <Form.Label style={{fontSize: '0.6em'}} className="my-0 py-0"
                      htmlFor={'period-'+index}>Period (months)</Form.Label>
                    <Form.Control
                      disabled={field.status===4?true:false}
                      key={'period-'+index}
                      type="number"
                      name="period"
                      value={field.period}
                      onChange={(event) => {
                        props.handleChange(index, event, props.yearCalc, props.remaining, props.selectedSort);
                      }}
                    />
                  </Col>
                  <Col xs={11} md={5} lg={1}>
                    <Form.Label style={{fontSize: '0.6em'}} className="my-0 py-0"
                      htmlFor={'periodw-'+index}>Period (weeks)</Form.Label>
                    <Form.Control
                      disabled={field.status===4?true:false}
                      key={'periodw-'+index}
                      type="number"
                      name="periodWeekly"
                      value={field.periodWeekly}
                      onChange={(event) => {
                        props.handleChange(index, event, props.yearCalc, props.remaining, props.selectedSort);
                      }}
                    />
                  </Col>
                  <Col xs={11} md={5} lg={2}>
                    <Form.Label style={{fontSize: '0.6em'}} className="my-0 py-0"
                      htmlFor={'status-'+index}>Status</Form.Label>
                    <Form.Select aria-label="select status"
                      key={'status-'+index}
                      id={'status-'+index}
                      name="status"
                      value={field.status}
                      onChange={(event) => {
                        props.handleChange(index, event, props.yearCalc, props.remaining, props.selectedSort);
                      }}
                    >
                    {statusOptions.map((s) => (<option key={s.value} value={s.value}>{s.desc}</option>))}
                    </Form.Select>
                  </Col>
                  <Col xs={11} md={5} lg={2}>
                    <Form.Label style={{fontSize: '0.6em'}} className="my-0 py-0"
                      htmlFor={'monthlyIndividual-'+index}>Monthly</Form.Label>
                    <InputGroup>
                      <InputGroup.Text>£</InputGroup.Text>
                      <Form.Control
                        disabled={field.status===4?true:false}
                        key={'monthlyIndividual-'+index}
                        type="number"
                        name="monthlyIndividual"
                        value={field.monthlyIndividual}
                        onBlur={(event) => props.handleBlurUpdate(index, event)}
                        onChange={(event) => {
                          props.handleChange(index, event, props.yearCalc, props.remaining, props.selectedSort);
                        }}
                      />
                    </InputGroup>
                  </Col>
                  <Col xs={11} md={5} lg={2}>
                    <Form.Label style={{fontSize: '0.6em'}} className="my-0 py-0"
                      htmlFor={'weeklyIndividual-'+index}>Weekly</Form.Label>
                    <InputGroup>
                      <InputGroup.Text>£</InputGroup.Text>
                      <Form.Control
                        disabled={field.status===4?true:false}
                        key={'weeklyIndividual-'+index}
                        type="number"
                        name="weeklyIndividual"
                        value={field.weeklyIndividual}
                        onBlur={(event) => props.handleBlurUpdate(index, event)}
                        onChange={(event) => {
                          props.handleChange(index, event, props.yearCalc, props.remaining, props.selectedSort);
                        }}
                      />
                    </InputGroup>
                  </Col>
                </Row></>:
                <>
                {props.data.repaymentType!=='PERCENTAGE'?
                  <Row>
                    <Col xs={11} md={5} lg={{ span: 4, offset: 1 }} className="text-lg-end my-auto">
                      Required for Snowball and Avalanche repayment types (automatic)
                    </Col>
                    <Col xs={11} md={5} lg={{ span: 1, offset: 4 }}>
                      <Form.Label style={{fontSize: '0.6em'}} className="my-0 py-0"
                        htmlFor={'apr-'+index}>APR
                      </Form.Label>
                      <Form.Control                    
                        key={'apr-'+index}
                        id={'apr-'+index}
                        className="mt-0"
                        type="number"
                        name="apr"
                        value={field.apr}
                        onChange={(event) => {
                          props.handleChange(index, event, props.yearCalc, props.remaining, props.selectedSort);
                        }}
                      />
                    </Col>
                    <Col xs={11} md={5} lg={1}>
                      <Form.Label style={{fontSize: '0.6em'}} className="my-0 py-0"
                        htmlFor={'min-pay-'+index}>Minimum Payment
                      </Form.Label>
                      <Form.Control                    
                        key={'min-pay-'+index}
                        id={'min-pay-'+index}
                        className="mt-0"
                        type="number"
                        name="minimumPayment"
                        value={field.minimumPayment}
                        onChange={(event) => {
                          props.handleChange(index, event, props.yearCalc, props.remaining, props.selectedSort);
                        }}
                      />
                    </Col>
                  </Row>:<></>}
                </>}
                <Row className="pb-3">
                  <Col xs={12} lg={{ span: 4, offset: 1}} className="text-lg-end my-auto">
                    Calculated using the { props.data.repaymentType.toLowerCase() } repayment type (automatic)
                  </Col>
                  <Col xs={11} md={2} lg={2}>
                    {props.data.repaymentType === 'PERCENTAGE'?
                    <>
                    <Form.Label style={{fontSize: '0.6em'}} className="my-0 py-0"
                      htmlFor={'percentage-'+index}>Percentage</Form.Label>
                    <InputGroup>
                      <Form.Control
                        disabled
                        key={'percentage-'+index}
                        type="text"
                        name="percentageOfDebt"
                        value={field.percentageOfDebt}
                      />
                      <InputGroup.Text>%</InputGroup.Text>
                    </InputGroup>
                    </>:<></>}
                  </Col>
                  <Col xs={11} md={2} lg={2}>
                    <Form.Label style={{fontSize: '0.6em'}} className="my-0 py-0"
                      htmlFor={'monthlyOverall-'+index}>Monthly</Form.Label>
                    <InputGroup>
                      <InputGroup.Text>£</InputGroup.Text>
                      <Form.Control
                        disabled
                        key={'monthlyOverall-'+index}
                        type="number"
                        name="monthlyOverall"
                        value={Number(field.monthlyOverall).toFixed(2)}
                      />
                    </InputGroup>
                  </Col>
                  <Col xs={11} md={2} lg={2}>
                    <Form.Label style={{fontSize: '0.6em'}} className="my-0 py-0"
                      htmlFor={'weeklyOverall-'+index}>Weekly</Form.Label>
                    <InputGroup>
                      <InputGroup.Text>£</InputGroup.Text>
                      <Form.Control
                        disabled
                        key={'weeklyOverall-'+index}
                        type="number"
                        name="weeklyOverall"
                        value={Number(field.weeklyOverall).toFixed(2)}
                      />
                    </InputGroup>
                  </Col>
                </Row>
                <div className="debt-payment-section">
                <Row className="payment-summary-row">
                  <Col xs={11} lg={{span: 2, offset: props.data.manual?0:3}} className="text-lg-end my-auto">
                    Payment Information:
                  </Col>
                  {props.data.manual?
                  <>
                  <Col xs={11} lg={2} className="my-auto">
                    <Form.Check
                      type="switch"
                      label="Monthly/Weekly payments"
                      id={"weekly-switch"+index}
                      checked={field.weekly}
                      onChange={() => props.handleChangeWeekly(index)}
                    />
                  </Col>
                  <Col xs={11} lg={1} className="payment-history-action">
                    <Button
                      id={'add-trans-'+index}
                      type="button"
                      size="sm"
                      variant="outline-primary"
                      className="add-payment-button"
                      onClick={() => props.handleAddTransaction(index, props.selectedSort)}
                    >
                      Add payment
                    </Button>
                  </Col>
                  </>:<></>}
                  <Col xs={11} lg={2} className="my-auto payment-history-actions payment-history-action">
                    <span
                      className='view'
                      role="button"
                      tabIndex={0}
                      aria-expanded={transactionsVisible}
                      onClick={() => setVisibleTransactions(current => ({
                        ...current,
                        [debtKey]: !current[debtKey],
                      }))}
                      onKeyDown={(event) => {
                        if (event.key === 'Enter' || event.key === ' ') {
                          event.preventDefault();
                          setVisibleTransactions(current => ({
                            ...current,
                            [debtKey]: !current[debtKey],
                          }));
                        }
                      }}
                    >
                      View payments {transactionsVisible?
                        <Icon.CaretUpSquareFill />:<Icon.CaretDownSquareFill />}
                    </span>
                  </Col>
                  <Col xs={11} md={5} lg={1} className="payment-history-summary-field">
                    <Form.Label style={{fontSize: '0.6em'}} className="my-0 py-0"
                      htmlFor={'noOfPayments-'+index}># of payments</Form.Label>
                    <Form.Control
                      disabled
                      key={'noOfPayments-'+index}
                      type="text"
                      name="noOfPayments"
                      value={field.noOfPayments}
                    />
                  </Col>
                  <Col xs={11} md={5} lg={1} className="payment-history-summary-field">
                    <Form.Label style={{fontSize: '0.6em'}} className="my-0 py-0"
                      htmlFor={'remainingPayments-'+index}># Remaining</Form.Label>
                    <Form.Control
                      disabled
                      key={'remainingPayments-'+index}
                      type="text"
                      name="remainingPayments"
                      value={calculateRemaining(field)}
                    />
                  </Col>
                  <Col xs={11} md={5} lg={2} className="payment-history-summary-field">
                    <Form.Label style={{fontSize: '0.6em'}} className="my-0 py-0"
                      htmlFor={'paymentsMade-'+index}>Amount Paid</Form.Label>
                    <InputGroup>
                      <InputGroup.Text>£</InputGroup.Text>
                      <Form.Control
                        disabled
                        key={'paymentsMade-'+index}
                        type="number"
                        name="paymentsMade"
                        value={Number(field.paymentsMade).toFixed(2)}
                      />
                    </InputGroup>
                  </Col>
                </Row>
                <Row id={'transactions' + index}
                  className={`${transactionsVisible?'show-trans':'hide-trans'} payment-transaction-list`}>
                  {visiblePayments.map(({payment: jField, paymentIndex: jndex}) => (
                  <Row key={jField.id || jndex} id={'transactions' + index + '-' + jndex}>
                    <Col  xs={11} md={5} lg={2}>
                      <Form.Control
                        key={'date-'+ jndex}
                        type="text"
                        name="date"
                        placeholder="Date"
                        value={jField.date}
                        onChange={(event) => {
                          props.handleChangeTransaction(event, index, jndex);
                        }}
                      />
                    </Col>
                    <Col  xs={11} md={5} lg={2}>
                      <InputGroup>
                        <InputGroup.Text>£</InputGroup.Text>
                        <Form.Control
                          key={'debit-'+ jndex}
                          type="number"
                          name="debit"
                          placeholder="Enter Debit"
                          value={jField.debit}
                          onBlur={(e) => props.handleBlurUpdateDebt(index, e)}
                          onChange={(event) => {
                            props.handleChangeTransaction(event, index, jndex);
                          }}
                        />
                      </InputGroup>
                    </Col>
                    <Col  xs={11} md={5} lg={2}>
                      <InputGroup>
                        <InputGroup.Text>£</InputGroup.Text>
                        <Form.Control
                          key={'paymentCredit-' + index}
                          type="number"
                          name="paymentCredit"
                          placeholder="Enter Amount"
                          value={jField.paymentCredit}
                          onBlur={(e) => props.handleBlurUpdateDebt(index, e)}
                          onChange={(event) => {
                            props.handleChangeTransaction(event, index, jndex);
                          }}
                        />
                      </InputGroup>
                    </Col>
                    <Col  xs={11} md={5} lg={1}>
                      <p>
                        <span className='plus_minus' onClick={() => props.handleRemoveTransaction(index, jndex, props.remaining, props.selectedSort)}>
                          <strong>-</strong>&nbsp;
                        </span>
                      </p>
                    </Col>
                  </Row>
                  ))}
                  {sortedPayments.length > 0?
                    <Col xs={12}>
                      <div className="payment-history-pagination">
                        <Form.Select
                          size="sm"
                          aria-label="Payment history display count"
                          value={pageSizeSelection}
                          onChange={(event) => {
                            setPaymentPageSizes(current => ({ ...current, [debtKey]: event.target.value }));
                            setPaymentPages(current => ({ ...current, [debtKey]: 1 }));
                          }}
                        >
                          <option value="5">5 per page</option>
                          <option value="all">View all</option>
                        </Form.Select>
                        {pageSizeSelection !== 'all' && pageCount > 1?
                          <Pagination size="sm" className="mb-0">
                            <Pagination.Prev
                              disabled={visiblePage === 1}
                              aria-label="Previous payment page"
                              onClick={() => setPaymentPages(current => ({ ...current, [debtKey]: visiblePage - 1 }))}
                            />
                            <Pagination.Item active>{visiblePage} of {pageCount}</Pagination.Item>
                            <Pagination.Next
                              disabled={visiblePage === pageCount}
                              aria-label="Next payment page"
                              onClick={() => setPaymentPages(current => ({ ...current, [debtKey]: visiblePage + 1 }))}
                            />
                          </Pagination>:<></>}
                      </div>
                    </Col>:<></>}
                </Row>
                  </div>
              </Card.Body>
            </Accordion.Collapse>
            <div className="record-actions">
              {props.data.records.length > 1?
              <Button type="button" variant="outline-danger" className="record-action-button"
                onClick={() => props.handleRemove(index, props.yearCalc, props.remaining, props.selectedSort)}>
                Remove debt
              </Button>:<></>}
              <Button type="button" variant="outline-primary" className="record-action-button"
                onClick={() => props.handleAdd(index + 1)}>
                Add debt
              </Button>
            </div>
          </Card>
        </Form>
      </Accordion>
      </React.Fragment>
    )})}
    </Row>
    </div>
      <Row style={{fontSize: '0.7em', textAlign: 'right'}}>
        <Col  xs={11} md={5} lg={6}>
          &nbsp;
        </Col>
        <Col  xs={11} md={5} lg={2}>
          Total Debt
        </Col>
        <Col xs={11} md={5} lg={2}>
          Current Debt
        </Col>
        <Col xs={1}>
          &nbsp;
        </Col>
      </Row>
      <Row>
        <Col  xs={11} md={5} lg={6} className="total-text">
          Total {props.title}
        </Col>
        <Col  xs={11} md={5} lg={2} className="total-text">
          £{Number(props.data.totalAmount).toFixed(2)}
        </Col>
        <Col xs={11} md={5} lg={2} className="total-text">
          £{roundNumber(props.data.totalAmount - props.data.totalCurrentBalance).toFixed(2)}
        </Col>
        <Col xs={1}>
          &nbsp;
        </Col>
      </Row>
      <Row style={{fontSize: '0.7em', textAlign: 'right'}}>
        <Col  xs={11} md={5} lg={6}>
          &nbsp;
        </Col>
        <Col  xs={11} md={5} lg={2}>
          Monthly
        </Col>
        <Col xs={11} md={5} lg={2}>
          Weekly
        </Col>
        <Col xs={1}>
          &nbsp;
        </Col>
      </Row>
      <Row>
        <Col  xs={11} md={5} lg={6} className="total-text">
          Automatic Payments:
        </Col>
        <Col  xs={11} md={5} lg={2} className="total-text">
          £{Number(props.data.totalPerMonthOverall).toFixed(2)}
        </Col>
        <Col xs={11} md={5} lg={2} className="total-text">
          £{Number(props.data.totalPerWeekOverall).toFixed(2)}
        </Col>
        <Col xs={1}>
          &nbsp;
        </Col>
      </Row>
      <Row>
        <Col  xs={11} md={5} lg={6} className="total-text">
          Manual Payments:
        </Col>
        <Col  xs={11} md={5} lg={2} className="total-text">
          £{Number(props.data.totalPerMonthIndividual).toFixed(2)}
        </Col>
        <Col xs={11} md={5} lg={2} className="total-text">
          £{Number(props.data.totalPerWeekIndividual).toFixed(2)}
        </Col>
        <Col xs={1}>
          &nbsp;
        </Col>
      </Row>
    </>
  );
}

export default DebtForm;